import { useCallback } from 'react';
import { useIntl } from 'react-intl';

/**
 * This is an escape hatch for dynamically composed text keys, such as country codes or hint texts.
 * It is not recommended to use this in most cases, as text keys should be statically defined.
 */
export const useIsTextKey = () => {
    const intl = useIntl();

    return useCallback(
        (textKey: unknown): textKey is Mews.TextKey => {
            return (textKey as PropertyKey) in intl.messages;
        },
        [intl]
    );
};
